/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Op_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed" |
*
* @param {Admin_Op_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const admin_op_error = /** @type {((inputs?: Admin_Op_ErrorInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Op_ErrorInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Falhou")
	if (locale === "it") return /** @type {LocalizedString} */ ("Errore")
	return /** @type {LocalizedString} */ ("Failed")
});